import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function SkeletonPulse({ className = "" }) {
  return (
    <div className={`rounded bg-white/[0.04] skeleton-shimmer ${className}`} />
  );
}

export function DashboardSkeleton() {
  return (
    <div className="space-y-6" data-testid="dashboard-skeleton">
      <div>
        <SkeletonPulse className="h-9 w-48 mb-2" />
        <SkeletonPulse className="h-4 w-72" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[0, 1, 2, 3].map(i => (
          <Card key={i} className="bg-[#0A0A0A] border-white/5">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <SkeletonPulse className="w-14 h-14 rounded-xl" />
                <div className="space-y-2">
                  <SkeletonPulse className="h-3 w-28" />
                  <SkeletonPulse className="h-8 w-36" />
                </div>
              </div>
              <SkeletonPulse className="h-3 w-full mt-4" />
              <div className="space-y-3 mt-4">
                <SkeletonPulse className="h-2 w-full" />
                <SkeletonPulse className="h-2 w-3/4" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <Card className="bg-[#0A0A0A] border-white/5">
        <CardHeader>
          <SkeletonPulse className="h-5 w-48" />
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            {[0, 1, 2, 3, 4].map(i => (
              <div key={i} className="bg-[#121212] rounded-lg p-3">
                <div className="flex items-start gap-3">
                  <SkeletonPulse className="w-10 h-10 rounded" />
                  <div className="space-y-2 flex-1">
                    <SkeletonPulse className="h-3 w-full" />
                    <SkeletonPulse className="h-2 w-2/3" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export function GamesSkeleton() {
  return (
    <div data-testid="games-skeleton">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {Array.from({ length: 15 }).map((_, i) => (
          <Card key={i} className="bg-[#0A0A0A] border-white/5 overflow-hidden">
            <CardContent className="p-0">
              <SkeletonPulse className="aspect-[3/4] w-full rounded-none" />
              <div className="p-3 space-y-2">
                <SkeletonPulse className="h-3 w-full" />
                <SkeletonPulse className="h-2 w-1/2" />
                <SkeletonPulse className="h-2 w-full" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

export function StatsSkeleton() {
  return (
    <div className="space-y-6" data-testid="stats-skeleton">
      <div>
        <SkeletonPulse className="h-9 w-40 mb-2" />
        <SkeletonPulse className="h-4 w-64" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map(i => (
          <Card key={i} className="bg-[#0A0A0A] border-white/5">
            <CardContent className="p-4">
              <SkeletonPulse className="h-3 w-20 mb-3" />
              <SkeletonPulse className="h-8 w-24 mb-2" />
              <SkeletonPulse className="h-2 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
      <Card className="bg-[#0A0A0A] border-white/5">
        <CardContent className="p-6">
          <SkeletonPulse className="h-64 w-full rounded-lg" />
        </CardContent>
      </Card>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {[0, 1, 2].map(i => (
          <Card key={i} className="bg-[#0A0A0A] border-white/5">
            <CardHeader>
              <SkeletonPulse className="h-4 w-32" />
            </CardHeader>
            <CardContent>
              <div className="space-y-3">
                {[0, 1, 2].map(j => (
                  <div key={j} className="flex items-center gap-3">
                    <SkeletonPulse className="w-7 h-7 rounded-full" />
                    <SkeletonPulse className="w-9 h-9 rounded" />
                    <div className="space-y-1 flex-1">
                      <SkeletonPulse className="h-3 w-full" />
                      <SkeletonPulse className="h-2 w-2/3" />
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
